import React from 'react';
import { ErrorTitle } from "./SharedStyles";

const ErrorPage = () => (
  <ErrorTitle>404</ErrorTitle>
)

export default ErrorPage;
